<div class="view-log">
  <div class="view-log-header">
    <label class="form-label mb-0">{{ title }}</label>
  </div>

  @if (displayLogs.length) {
    <div class="view-log-timeline">
      @for (log of displayLogs; track trackByLog($index, log)) {
        <div class="view-log-item">
          <span class="view-log-dot"></span>
          <div class="view-log-content">
            <div class="view-log-title">{{ log.actionType }} by {{ log.actorName }}</div>
            @if (log.description) {
              <div class="view-log-description">{{ log.description }}</div>
            }
            <div class="view-log-date">{{ log.actionOnText }}</div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="view-log-empty">No activity recorded yet.</div>
  }

</div>
